module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/icon--gmail-2957d8d4.png";